import { defineMessages } from 'react-intl';

export const LoginPageMessages = defineMessages({
  headTitle: {
    id: 'login.head.title',
    defaultMessage: 'Log in to continue',
  },
  contextualTitle: {
    id: 'login.contextual.title',
    defaultMessage: 'Continue to',
    description: `Precedes a page title or issue number. For example, "Continue to Sarah's Blogpost" or "Continue to TED-1024"`,
  },
  socialAuthOr: {
    id: 'social.auth.or',
    defaultMessage: 'or',
  },
  socialAuthOrContinueWith: {
    id: 'social.auth.or-continue-with',
    defaultMessage: 'Or continue with:',
  },
  createAnAccount: {
    id: 'login.create.an.account',
    defaultMessage: 'Create an account',
  },
  passwordlessSuccessTitle: {
    id: 'login.passwordless.success.title',
    defaultMessage: 'Email sent',
  },
  passwordlessSuccessDescription: {
    id: 'login.passwordless.success.description',
    defaultMessage: "We've sent you an email to log in.",
  },
  socialFormHeader: {
    id: 'login.social.form.header',
    defaultMessage: 'Log in',
    description:
      'Subtle header shown on the social login form which allows users to login with the chosen social provider',
  },
  socialFormTitle: {
    id: 'login.social.form.title',
    defaultMessage: 'You logged in with your {socialProviderName} account before',
    description:
      'Title shown on the social login form which allows users to login with the chosen social provider',
  },
  socialFormUseDifferentLoginMethod: {
    id: 'login.social.form.use-different-login-method',
    defaultMessage: 'Use a different login method',
    description:
      'Button label shown on the social login form which allows users to login using another method. Takes the user back to the original login form.',
  },
  continueAs: {
    id: 'continue.as.title.as',
    defaultMessage: 'Continue as',
    description: 'This is a page title that will be followed by an avatar hero with name and email',
  },
});
